import { Route, Routes } from "react-router-dom";

import Login from "./Login";
import SignUp from "./SignUp";
import Home from "./Home";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/register" element={<SignUp />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route index element={<Home />}></Route>
      </Routes>
    </div>
  );
}

export default App;
